'use client';

import { cn } from '@/lib/utils';
import { useI18n } from '@/lib/i18n';
interface HoverImagePanelProps {
  isOpen: boolean;
  position: {
    top: number;
    left: number;
  } | null;
  images: string[];
  title: string; // Used for alt text context
  className?: string;
}
export default function HoverImagePanel({
  isOpen,
  position,
  images,
  title,
  className
}: HoverImagePanelProps) {
  const {
    t
  } = useI18n();
  if (!isOpen || !position) {
    return null;
  }

  // Always take up to 4 images for a 2x2 grid display
  const displayImages = images.slice(0, 4);
  return <div className={cn('fixed z-50 pt-2 pb-4 px-4 bg-white rounded-[8px] shadow-2xl border border-slate-200', 'w-[450px]', 'animate-fade-in', className)} style={{
    left: `${position.left}px`,
    top: `${position.top}px`
  }} data-sentry-component="HoverImagePanel" data-sentry-source-file="HoverImagePanel.tsx">
      <div className="grid grid-cols-2 gap-3">
        {displayImages.map((src, index) => <div key={index} className="relative aspect-[2/3] rounded-[8px] overflow-hidden shadow bg-slate-100">
            <img src={src || '/placeholder.svg?height=152&width=203&query=example+headshot'} alt={`${title} example ${index + 1}`} sizes="203px" className="absolute inset-0 w-full h-full object-cover [object-position:0%_0%]" />
          </div>)}
      </div>
      {displayImages.length === 0 && <div className="flex items-center justify-center h-[300px]">
          {/* Approx height of 2x2 grid */}
          <p className="text-sm text-slate-500 p-1">
            {t('common.no_example_images_available')}
          </p>
        </div>}
    </div>;
}